import React, { useState } from "react";
import { Rectangle, InfoWindow } from "@react-google-maps/api";
import { Site } from "../../types/site";
import { convertSiteToBound } from "../../utils/siteUtils";

type Props = {
  site: Site;
  basePath: string;
};

const SiteRectangle: React.FC<Props> = ({ site, basePath }) => {
  const [active, setActive] = useState(false);

  const bounds = convertSiteToBound(site);

  const options = {
    strokeColor: "#14126f",
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: "#14126f",
    fillOpacity: 0.35,
    visible: true,
  };

  const center = {
    lat: (site.northExtremity + site.southExtremity) / 2.0,
    lng: (site.westExtremity + site.eastExtremity) / 2.0,
  };

  const onClick = () => {
    setActive(true);
  };
  const onCloseClick = () => {
    setActive(false);
  };

  return (
    <>
      {active && (
        <InfoWindow position={center} onCloseClick={onCloseClick}>
          <div className="text-sm">
            <h4 className="text-md">{site.name}</h4>
            <dt>会社:</dt>
            <dd>{site.customerName}</dd>
            <a href={`${basePath}/sites/${site.id}`} target="_blank" className="text-sm" rel="noreferrer">
              詳細
            </a>
          </div>
        </InfoWindow>
      )}
      <Rectangle bounds={bounds} options={options} onClick={onClick} />
    </>
  );
};

export default SiteRectangle;
